import styled from '@emotion/styled';
import { Stack } from '@mui/material';

export const FormSections = styled(Stack)({
  flexDirection: 'column',
  gap: '20px',
});

export const FieldSection = styled(Stack)({
  flexDirection: 'column',
  alignSelf: 'stretch',
  gap: '8px',
});

export const FieldRows = styled(Stack)({
  flexDirection: 'column',
  gap: '8px',
});

export const ValueRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'flex-end',
  gap: '8px',
  '& > *': { flex: '0 0 auto' },
  '& > *:first-child': { flex: '1 1 auto', minWidth: 0 },
});

export const SocialRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'flex-end',
  gap: '8px',
  '& > *': { flex: '0 0 auto' },
  '& > *:first-child': { width: '144px', flex: '0 0 144px' },
  '& > *:nth-child(2)': { flex: '1 1 auto', minWidth: 0 },
});

export const AddSectionRow = styled(Stack)({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '8px',
});

export const TypeTabs = styled('div')({
  '& [role="tablist"]': {
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
  },
  '& [role="tab"]': {
    flex: 1,
    justifyContent: 'center',
  },
});
